import * as api from './api'

export { apiRequest, apiClient, apiSettings } from './core'
export default api
